import { Injectable } from '@angular/core'

import { IFlowplayerConfiguration, IFlowplayerVideoPlayer } from './'

type FlowplayerApi = (
  elementOrSelector: string|HTMLElement, configuration?: IFlowplayerConfiguration
) => IFlowplayerVideoPlayer

interface FlowplayerApiAdapter {
  createOrFindBySelector: (elementSelector: string, config?: IFlowplayerConfiguration) => IFlowplayerVideoPlayer
}

@Injectable()
export class FlowplayerService implements FlowplayerApiAdapter {

  public static readonly DEFAULT_CONFIG = {
    clip: undefined,
    speeds: [0.5, 0.75, 1, 1.25, 1.5, 2],
    share: false,
    ratio: '3/4',
    fullscreen: true
  } as IFlowplayerConfiguration

  private _configDefaults: IFlowplayerConfiguration
  private get _globalFlowplayerApi(): FlowplayerApi {
    return this._windowObject['flowplayer']
  }

  private readonly _apiKey: string

  // Using the global "window" here, because flowplayer will be loaded
  // asyncronously/independently. This way, we can lazily evaluate the global
  // flowplayer objects at runtime so that they'll only be accessed when needed
  // at which point they've hopefully been loaded

  // TODO [GitHub Issue]:  figure out how to properly add the window type for specs
  // see: https://github.com/ManhattanPrep/js-libs/pull/78
  constructor(
    private _windowObject
  ) {
    this._apiKey = '$930323356072579'
    this._configDefaults = this._defaultConfigWithApiKey(this._apiKey)
  }

  public createOrFindBySelector(elementSelector: string, config?: IFlowplayerConfiguration): IFlowplayerVideoPlayer {
    const defaultedConfig = this._augmentWithDefaultConfig(config)
    return this.getFlowplayerApi()(elementSelector, defaultedConfig)
  }

  public getFlowplayerApi(): FlowplayerApi {
    return this._globalFlowplayerApi
  }

  private _augmentWithDefaultConfig(config?: IFlowplayerConfiguration) {
    return Object.assign({}, this._configDefaults, config || {})
  }

  private _defaultConfigWithApiKey(apiKey: string) {
    return Object.assign({}, FlowplayerService.DEFAULT_CONFIG, {key: apiKey})
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/flowplayer/flowplayer.service.ts